<template>
  <Main>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-6">
            <v-row>
              <v-col cols="12">
                <strong>AAM - VIEW MAPPING ASSIGNMENT</strong>
              </v-col>
            </v-row>
            <!--<v-row>
                        <v-col cols="2" align-self="center">Find By Position:</v-col>
                        <v-col cols="auto">
                            <v-autocomplete v-model="position" :items="positionList" :loading="isLoadingPosition" item-text="text" item-value="value" label="Position" color="red darken-1" class="pa-0" @change="populateDataTable()"></v-autocomplete>
                        </v-col>
                    </v-row>-->
            <v-row>
              <v-col md="6" sm="6">
                <v-btn color="warning" @click="exportCSV()">Export Excel</v-btn>
              </v-col>
              <v-spacer />
              <v-col class="text-right" cols="6">
                <v-text-field
                  color="red darken-1"
                  v-model="dtSearch"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  class="pa-0"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="dtHeaders"
                  :items="dtItems"
                  :search="dtSearch"
                  :loading="dtLoading"
                  loading-text="Fetching Data..."
                  dense
                >
                  <template v-slot:item.edit="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item.ASSIGNMENT_MAP_ID)"
                      >mdi-pencil</v-icon
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

const dtHeaders = [
  {
    text: "SALES ASSIGNMENT",
    value: "ASSIGMENT_NUMBER",
  },
  {
    text: "POSITION",
    value: "POSITION_CODE",
  },
  {
    text: "SALESMAN NAME",
    value: "SALESREP_EMPLOYEE_NAME",
  },
  {
    text: "ADD SALESMAN POSITION",
    value: "ADD_SALESMAN_POSITION",
  },
  {
    text: "BISNIS",
    value: "BISNIS",
  },
  {
    text: "TYPE DESC",
    value: "TYPE_DESC",
  },
  {
    text: "CUSTOMER ID REF",
    value: "CUSTOMER_ID",
  },
  {
    text: "CUSTOMER NAME",
    value: "CUSTOMER_NAME",
  },
  {
    text: "CHANNEL",
    value: "SALES_CHANNEL",
  },
  {
    text: "TERRITORY GEO GROUP",
    value: "SALES_TERRITORY_NAME",
  },
  {
    text: "START DATE",
    value: "ASSIGNMENT_START_DATE",
  },
  {
    text: "END DATE",
    value: "ASSIGNMENT_END_DATE",
  },
  {
    text: "EDIT",
    value: "edit",
    sortable: false,
  },
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      position: 0,
      positionList: [
        {
          text: "ALL POSITION",
          value: 0,
        },
      ],
      isLoadingPosition: false,
      dtHeaders,
      dtItems: [],
      dtLoading: false,
      dtSearch: "",
    };
  },
  mounted() {
    this.populateDataTable();
    // this.getpositionList();
  },
  methods: {
    // getpositionList() {
    //     this.dtLoading = true;
    //     this.$http
    //         .post("/mapping-sales-assignment/listPosition", {
    //             orgID: JSON.parse(
    //                 localStorage.getItem("userData")
    //             ).ORG_ID
    //         })
    //         .then((res) => {
    //             const {
    //                 data
    //             } = res.data;
    //             for (let PL of data) {
    //                 let positionList = {
    //                     text: PL.SALESREP_TYPE_CODE,
    //                     value: PL.SALESREP_POSITION_CODE,
    //                 };
    //                 this.positionList.push(positionList);
    //             }
    //             this.dtLoading = false;
    //         })
    //         .catch((err) => {
    //             this.dtLoading = false;
    //             this.showSnackbar(err.toString());
    //         });
    // },
    exportCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItems);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Overview Mapping Sales Assignment.xlsx"); // initiate a file download in browser
    },
    populateDataTable() {
      this.dtLoading = true;
      let bindParams = {
        positionCode: this.position,
        orgID: JSON.parse(localStorage.getItem("userData")).ORG_ID,
      };
      this.$http
        .post("/mapping-sales-assignment/select", bindParams, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          const { data } = res.data;
          console.log(res);
          data.forEach((val, index) => {
            data[index].ASSIGNMENT_START_DATE = moment(
              data[index].ASSIGNMENT_START_DATE
            ).format("YYYY-MM-DD");
            data[index].ASSIGNMENT_END_DATE = moment(
              data[index].ASSIGNMENT_END_DATE
            ).format("YYYY-MM-DD");
            data[index].ASSIGNMENT_LAST_UPDATE = moment(
              data[index].ASSIGNMENT_LAST_UPDATE
            ).format("YYYY-MM-DD");
          });

          this.dtLoading = false;
          this.dtItems = data;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    editItem(ASSIGNMENT_MAP_ID) {
      console.log(ASSIGNMENT_MAP_ID);
      this.$router.push({
        path: `/mapping-sales-assignment/edit/${ASSIGNMENT_MAP_ID}`,
      });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
